export const mergeCompanyLabel = (name: string) =>
	`Merge ${name.trim() || "company"} with...`

export const mergeCompanyTargets = <T extends { id: string }>(
	companies: readonly T[],
	currentId: string,
) => companies.filter((company) => company.id !== currentId)

export const mergeCompanyEmptyMessage = (query: string) =>
	query.trim()
		? "No matching companies. The current company is left out of the list."
		: "No other companies to merge with."
